import { MOSIDA_API_BASE_URL } from "../config/apiUrls";

const apiBase = MOSIDA_API_BASE_URL;

export const SELECTED_FIFA_TEAM_STORAGE_KEY = "selectedFifaTeam";

export interface FifaCountry {
  id: string;
  name: string;
  code: string;
  flag: string | null;
  flag_url: string | null;
}

export interface FifaTeam {
  id: string;
  name: string;
  team_logo: string | null;
  team_logo_url: string | null;
  league_name: string | null;
  league_logo: string | null;
  league_logo_url: string | null;
  jersey_image: string | null;
  country_id: string;
  country: FifaCountry | null;
  sort_order: number | null;
}

function getHeaders(): HeadersInit {
  return {
    accept: "application/json",
  };
}

export function persistSelectedFifaTeam(team: FifaTeam): void {
  try {
    localStorage.setItem(SELECTED_FIFA_TEAM_STORAGE_KEY, JSON.stringify(team));
  } catch {
    /* ignore storage errors */
  }
}

export function readSelectedFifaTeam(): FifaTeam | null {
  try {
    const raw = localStorage.getItem(SELECTED_FIFA_TEAM_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as FifaTeam;
  } catch {
    return null;
  }
}

export async function getFifaTeams(): Promise<{
  success: boolean;
  data: FifaTeam[];
  error?: string;
  message?: string;
}> {
  try {
    const response = await fetch(`${apiBase}/fifa-teams`, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      const text = await response.text();
      return {
        success: false,
        data: [],
        error: `Failed to load FIFA teams: ${response.status} ${text}`,
      };
    }

    const json = await response.json();
    const data = Array.isArray(json?.data) ? json.data : [];
    return {
      success: Boolean(json?.success !== false),
      data,
      message: json?.message,
      error: json?.success === false ? json?.message : undefined,
    };
  } catch (error: unknown) {
    const message =
      error instanceof Error
        ? error.message
        : "Network error while loading FIFA teams";
    return {
      success: false,
      data: [],
      error: message,
    };
  }
}
